<template>
    <hr>
    <ideo-form-group :label="$t('[[[Wybierz stronę]]]')" :invalid-feedback="form.$errors.first('settings.page')" :state="form.$errors.state('settings.page')" required>
        <edito-page-selector v-model="form.settings.page" :module="module" label="" :website="false" :preview="false" class="mb-0" />
    </ideo-form-group>
    <ideo-form-group :label="$t('[[[Rotator]]]')" :invalid-feedback="form.$errors.first('settings.opinionSlider')" :state="form.$errors.state('settings.opinionSlider')" required>
        <ideo-autocomplete
            v-model="form.settings.opinionSlider"
            name="settings.opinionSlider"
            track-by="id"
            :placeholder="$t('[[[zacznij pisać aby wyszukać rotator...]]]')"
            :fetch="(id: number) => fetchSlider(id)"
            :search="(query: string, limit: number) => searchSliders(query, limit)"
            :disabled="form.language === null"
        >
            <template #selected="{ option }">
                <div class="text-wrap">
                    {{ option.name }}
                </div>
            </template>
            <template #option="{ option }">
                <div class="text-wrap">
                    {{ option.name }}
                </div>
            </template>
        </ideo-autocomplete>
    </ideo-form-group>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Emit, Prop, Watch } from '@/helpers/Decorators';
import { FormType } from '@/helpers/Form';
import { ValidatableComponent } from '@/components/cms';
import merge from 'lodash/merge';
import OpinionSlidersService, { ListItemModel } from '@/modules/cms/opinion-sliders/services/OpinionSlidersService';

interface FormSettings
{
    settings: any;
}

@Options({
    name: 'widget-opinion-slider-settings'
})
export default class OpinionSliderSettings extends Vue implements ValidatableComponent
{
    @Prop() public modelValue!: any;

    public module: string = 'articles';
    public defaults: any = {
        page: null,
        opinionSlider: ''
    };

    public get form(): FormType<FormSettings>
    {
        return this.modelValue;
    }

    public async created(): Promise<void>
    {
        this.form.settings = merge(this.defaults, this.form.settings);
    }

    @Watch('form.settings', { deep: true })
    public onSettingsChanged(value: any): void
    {
        this.triggetModel();
    }

    @Emit('update:modelValue')
    public triggetModel(): any
    {
        return this.form;
    }

    public async validate(): Promise<void>
    {
    }

    public async fetchSlider(id: number): Promise<ListItemModel>
    {
        if (id != 0)
        {
            const response = await OpinionSlidersService.fetchAutocompleteModel(id);

            return response || null;
        }

        return null;
    }

    public async searchSliders(query: string, limit: number): Promise<ListItemModel[]>
    {
        return await OpinionSlidersService.getAutocompleteList(query, limit);
    }
}
</script>
